import { Deserializable } from './../shared/Deserializable';
import { Documento } from './Documento';
import { Bloqueo } from './Bloqueo';
export class Persona implements Deserializable {
  country?: string;
  score?: number;

  iup?: number;
  rutHash?: string;
  rut?: string;
  cedula?: string;
  dniDoc?: string;

  entityKey?: string;
  cedulaHash?: string;
  nationalId?: string;
  nationalIdHash?: string;
  patente?: string;
  patenteHash?: string;

  hash?: string;
  personaHash?: string;

  documentos?: Array<Documento>;
  tipoPersona?: string;
  nombres?: string;
  apellidos?: string;
  sexo?: string;
  celulares?: Array<string>;
  nacimientoFh?: string;
  nacimientoAnio?: string;
  denominacion?: string;
  bloqueos?: Array<Bloqueo>;
  validado?: string;
  validadoFh?: string;
  validadoFuente?: string;
  fallecido?: string;
  emails?: Array<string>;
  idsDigitales?: Array<string>
  baja?: string;
  acciones?: Array<string>;
  tipoSocietario?: string;
  perOrEmp?: string;
  documento?: string;
  seleccionado?: boolean;
  entityType?: string;
  keying?: any[];
  documento_numero?: any;

  constructor(documento: Documento) {
    this.documentos = [documento]
  }

  deserialize(input: any) {
    Object.assign(this, input);
    return this;
  }

  // public get documentoDNI() {
  //   let documento: Documento = null;
  //   if (this.documentos !== undefined) {
  //     if (this.documentos.length !== 0) {
  //       for (let doc of this.documentos) {
  //         if (doc.tipo === "DNI") {
  //           documento = doc;
  //           break;
  //         }
  //       }
  //     }
  //   }
  //   return documento;
  // }

  // public get documentCUIT() {
  //   let documento: Documento = null;
  //   if (this.documentos !== undefined) {
  //     if (this.documentos.length !== 0) {
  //       for (let doc of this.documentos) {
  //         if (doc.tipo === "CUIT") {
  //           documento = doc;
  //           break;
  //         }
  //       }
  //     }
  //   }
  //   return documento;
  // }

  // dni(country: string) {
  //   return "this";
  // }

}
